import React, { useEffect } from 'react';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import CustomCursor from './components/UI/CustomCursor';
import './styles/globals.css';
import { Route, Routes } from 'react-router-dom';
import Home from './components/UI/Home';

// Import Home Sections (Assuming you move them to separate files)
// import Hero from './components/home/Hero';
// import About from './components/home/About';

const App: React.FC = () => {
  useEffect(() => {
    // Reveal Animation Logic
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.12 });

    document.querySelectorAll('.reveal').forEach((el) => observer.observe(el));
    
    return () => observer.disconnect();
  }, []);

  return (
    <>
     
      <Header />
      
      <main>
        <Routes>
          {/* Landing Page */}
          <Route path="/" element={<Home />} />

          {/* Example: Single Property Page */}
          {/* <Route path="/property/:id" element={<PropertyDetails />} /> */}

          {/* 404 Page Not Found */}
          <Route path="*" element={<h1>404 - Page Not Found</h1>} />
        </Routes>
      </main>

      <Footer />
    </>
  );
};

export default App;